// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__QGwTU","notes":"Notes_notes__1rWuT","note":"Notes_note__3sr4Z","markdown":"Notes_markdown__OYwiR"};